module.exports = __webpack_public_path__ + "img/07_shimizu_07.0698231c.jpg";